"use client";

import { c as _c } from "react/compiler-runtime";
import { useEmailComposer } from "./context";
import { SaveTemplateButton } from "./save-template-dialog";
interface SaveAsTemplateProps {
  /** The surface's subject line, used to prefill the dialog. */
  subject?: string;
  disabled?: boolean;
}

/**
 * Compound slot for the shared EmailComposer: saves the composer's current
 * body as a template, reading the editor from context (no ref threading).
 * The mirror of `LoadTemplate`, so any surface can offer both with one line
 * each.
 */
export function SaveAsTemplate(t0) {
  const $ = _c(6);
  const {
    subject,
    disabled
  } = t0;
  const {
    editor
  } = useEmailComposer();
  const t1 = disabled || !editor;
  let t2;
  if ($[0] !== editor) {
    t2 = () => ({
      body: JSON.stringify(editor?.getJSON() ?? {
        type: "doc",
        content: []
      }),
      bodyFormat: "TIPTAP_JSON"
    });
    $[0] = editor;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== subject || $[3] !== t1 || $[4] !== t2) {
    t3 = <SaveTemplateButton disabled={t1} defaultSubject={subject} getTemplateBody={t2} />;
    $[2] = subject;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}